/* We Love Colors – color heart. Equal-area wedges, gradient order = data order.
   Works on the static mockup and inside the Liquid section (same file). */
(function(){
  var NS='http://www.w3.org/2000/svg';
  function lum(hex){ if(!hex) return 60; var h=hex.replace('#','');
    var c=[0,2,4].map(function(i){var v=parseInt(h.substr(i,2),16)/255;return v<=.04045?v/12.92:Math.pow((v+.055)/1.055,2.4)});
    var Y=.2126*c[0]+.7152*c[1]+.0722*c[2]; return 116*(Y>.008856?Math.cbrt(Y):7.787*Y+16/116)-16; }
  function el(n,a){var e=document.createElementNS(NS,n);for(var k in a)e.setAttribute(k,a[k]);return e;}
  function heartPoly(){var P=[];for(var i=0;i<480;i++){var t=i/480*Math.PI*2;
    P.push([16*Math.pow(Math.sin(t),3),-(13*Math.cos(t)-5*Math.cos(2*t)-2*Math.cos(3*t)-Math.cos(4*t))]);}return P;}
  function inside(P,x,y){var c=false;for(var i=0,j=P.length-1;i<P.length;j=i++){var xi=P[i][0],yi=P[i][1],xj=P[j][0],yj=P[j][1];
    if(((yi>y)!=(yj>y))&&(x<(xj-xi)*(y-yi)/(yj-yi)+xi))c=!c;}return c;}

  function init(root){
    var data=JSON.parse(root.querySelector('script[data-heart-json]').textContent);
    var colors=data.colors, N=colors.length, interactive=root.getAttribute('data-interactive')!=='false';
    var P=heartPoly(), S=[], sx=0, sy=0;
    for(var x=-16;x<=16;x+=.3)for(var y=-13;y<=17.5;y+=.3)if(inside(P,x,y)){S.push([x,y]);sx+=x;sy+=y;}
    var cx=sx/S.length, cy=sy/S.length;                 // centroid = wedge hub
    P=P.map(function(p){return [p[0]-cx,p[1]-cy]});
    var ang=S.map(function(p){var a=Math.atan2(p[0]-cx,-(p[1]-cy));return a<0?a+2*Math.PI:a}).sort(function(a,b){return a-b});
    var B=[0];for(var k=1;k<N;k++)B.push(ang[Math.floor(k*ang.length/N)]);B.push(2*Math.PI);
    var xs=P.map(function(p){return p[0]}), ys=P.map(function(p){return p[1]}), pad=2.2;
    var minX=Math.min.apply(0,xs)-pad, minY=Math.min.apply(0,ys)-pad, W=Math.max.apply(0,xs)+pad-minX, H=Math.max.apply(0,ys)+pad-minY;
    var svg=root.querySelector('[data-heart-svg]');
    svg.setAttribute('viewBox',[minX,minY,W,H].map(function(v){return v.toFixed(3)}).join(' '));
    var hd='M'+P.map(function(p){return p[0].toFixed(3)+','+p[1].toFixed(3)}).join('L')+'Z';
    var uid='h'+Math.random().toString(36).slice(2,7), defs=el('defs',{});
    var cp=el('clipPath',{id:uid+'c',clipPathUnits:'userSpaceOnUse'});cp.appendChild(el('path',{d:hd}));defs.appendChild(cp);
    var pat=el('pattern',{id:uid+'t',width:1.2,height:1.2,patternUnits:'userSpaceOnUse',patternTransform:'rotate(45)'});
    pat.appendChild(el('rect',{width:1.2,height:1.2,fill:'#ff6a1a'}));pat.appendChild(el('rect',{width:.45,height:1.2,fill:'#ffc9a6'}));defs.appendChild(pat);
    svg.appendChild(defs);
    var g=el('g',{'class':'hw-wedges'});svg.appendChild(g);
    var R=40, wedges=[];
    colors.forEach(function(c,i){
      var a0=B[i],a1=B[i+1],d='M0,0',steps=Math.max(2,Math.ceil((a1-a0)/.02));
      for(var s=0;s<=steps;s++){var a=a0+(a1-a0)*s/steps;d+='L'+(R*Math.sin(a)).toFixed(3)+','+(-R*Math.cos(a)).toFixed(3);}
      var m=(a0+a1)/2, a=el('a',{'class':'hw','data-i':i,'data-fam':c.family_id,href:c.url,tabindex:'-1','aria-hidden':'true'});
      a.style.setProperty('--dx',(Math.sin(m)*.7).toFixed(3)+'px');a.style.setProperty('--dy',(-Math.cos(m)*.7).toFixed(3)+'px');
      a.appendChild(el('path',{d:d+'Z','clip-path':'url(#'+uid+'c)',fill:c.hex||'url(#'+uid+'t)'}));
      g.appendChild(a);wedges.push(a);
    });
    // family separators
    var sep=el('g',{'class':'hw-sep','clip-path':'url(#'+uid+'c)'});
    colors.forEach(function(c,i){var prev=colors[(i-1+N)%N];if(prev.family_id!==c.family_id){var a=B[i];
      sep.appendChild(el('line',{x1:0,y1:0,x2:(R*Math.sin(a)).toFixed(3),y2:(-R*Math.cos(a)).toFixed(3)}));}});
    svg.appendChild(sep);
    svg.appendChild(el('path',{d:hd,'class':'hw-outline'}));
    if(!interactive) return;

    var pill=root.querySelector('[data-heart-pill]'), cta=root.querySelector('[data-heart-cta]');
    if(pill){pill.style.left=((0-minX)/W*100)+'%';pill.style.top=((0-minY)/H*100)+'%';}
    var pDot=pill&&pill.querySelector('[data-pill-dot]'), pName=pill&&pill.querySelector('[data-pill-name]'), pMeta=pill&&pill.querySelector('[data-pill-meta]');
    var def={name:pName?pName.textContent:'',meta:pMeta?pMeta.textContent:''}, ctaDef=cta?cta.innerHTML:'', ctaHref=cta?cta.getAttribute('href'):'';
    var cur=-1, lastPointer='mouse';
    function meta(c){return (c.count!=null&&c.count!==''?c.count+' products':'Count TBD')+(c.hex?'':' · hex TBD');}

    // --- Popular in this color row (AJAX via Section Rendering API) ---
    var row=root.querySelector('[data-heart-row]'), rowItems=row&&row.querySelector('[data-row-items]'), rowAll=row&&row.querySelector('[data-row-all]');
    var rowCache={}, rowTimer=null, rowKey=row?'__default':null, rowCtl=null;
    if(rowItems) rowCache.__default=rowItems.innerHTML;
    function rowUrl(u){return u+(u.indexOf('?')>-1?'&':'?')+'section_id=color-heart-row';}
    function setRowName(n,u){if(!row)return;row.querySelectorAll('[data-row-name]').forEach(function(s){s.textContent=n});if(rowAll)rowAll.setAttribute('href',u);}
    function loadRow(c){
      if(!row) return; clearTimeout(rowTimer);
      rowTimer=setTimeout(function(){
        if(rowKey===c.key) return; rowKey=c.key; setRowName(c.name,c.url);
        if(rowCache[c.key]!=null){rowItems.innerHTML=rowCache[c.key];return;}
        if(rowCtl) rowCtl.abort(); rowCtl=window.AbortController?new AbortController():null;
        rowItems.setAttribute('aria-busy','true'); row.classList.add('is-loading');
        fetch(rowUrl(c.url),{signal:rowCtl?rowCtl.signal:undefined,credentials:'same-origin'}).then(function(r){if(!r.ok)throw r;return r.text()}).then(function(h){
          var d=new DOMParser().parseFromString(h,'text/html'), n=d.querySelector('[data-row-items]');
          var html=n?n.innerHTML:'<p class="wlc-row__empty">Could not load products.</p>'; rowCache[c.key]=html;
          if(rowKey===c.key) rowItems.innerHTML=html;
        }).catch(function(e){if(e&&e.name==='AbortError')return;}).then(function(){rowItems.setAttribute('aria-busy','false');row.classList.remove('is-loading');});
      }, lastPointer==='mouse'?220:0);
    }
    function activate(i){
      if(cur===i) return; clear(true); cur=i; var w=wedges[i], c=colors[i];
      w.classList.add('on'); g.appendChild(w); root.classList.add('has-on');
      if(pill){pDot.style.background=c.hex||'';pDot.classList.toggle('tbd',!c.hex);pDot.classList.toggle('light',lum(c.hex)>85);
        pName.textContent=c.name;pMeta.textContent=meta(c)+' · Shop →';pill.classList.add('on');}
      if(cta){cta.setAttribute('href',c.url);cta.innerHTML='Shop all '+c.name.replace(/&/g,'&amp;')+' <span>'+meta(c)+'</span> →';}
      root.querySelectorAll('[data-list-i]').forEach(function(r){r.classList.toggle('on',+r.getAttribute('data-list-i')===i)});
      loadRow(c);
    }
    function clear(keep){
      if(cur>-1){wedges[cur].classList.remove('on');}
      cur=-1; root.classList.remove('has-on');
      root.querySelectorAll('[data-list-i].on').forEach(function(r){r.classList.remove('on')});
      if(keep) return;
      if(pill){pName.textContent=def.name;pMeta.textContent=def.meta;pDot.style.background='';pDot.classList.remove('tbd','light');pill.classList.remove('on');}
      if(cta){cta.innerHTML=ctaDef;cta.setAttribute('href',ctaHref);}
    }
    svg.addEventListener('pointerdown',function(e){lastPointer=e.pointerType});
    svg.addEventListener('pointerleave',function(e){if(e.pointerType==='mouse')clear()});
    wedges.forEach(function(w,i){
      w.addEventListener('pointerenter',function(e){if(e.pointerType==='mouse')activate(i)});
      w.addEventListener('click',function(e){ if(lastPointer!=='mouse'&&cur!==i){e.preventDefault();activate(i);} }); // touch: 1st tap previews, 2nd tap shops
    });
    // list fallback drives the heart too
    root.querySelectorAll('[data-list-i]').forEach(function(r){var i=+r.getAttribute('data-list-i');
      r.addEventListener('mouseenter',function(){activate(i)});r.addEventListener('focus',function(){activate(i)});
      r.addEventListener('mouseleave',function(){clear()});r.addEventListener('blur',function(){clear()});});
    // family legend / filter
    var btns=root.querySelectorAll('[data-fam-btn]'), status=root.querySelector('[data-fam-status]');
    function setFam(f){
      btns.forEach(function(b){b.setAttribute('aria-pressed',String(b.getAttribute('data-fam-btn')===f))});
      root.classList.toggle('is-filter',f!=='all');
      wedges.forEach(function(w){w.classList.toggle('fam-on',w.getAttribute('data-fam')===f)});
      root.querySelectorAll('[data-fam-group]').forEach(function(gp){gp.classList.toggle('fam-on',gp.getAttribute('data-fam-group')===f)});
      if(status){var n=colors.filter(function(c){return c.family_id===f}).length;
        status.textContent=f==='all'?'Showing all '+N+' colors':'Highlighting '+n+' '+(data.families.filter(function(x){return x.id===f})[0]||{}).name+' in the heart';}
    }
    btns.forEach(function(b){b.addEventListener('click',function(){var f=b.getAttribute('data-fam-btn');
      setFam(b.getAttribute('aria-pressed')==='true'&&f!=='all'?'all':f);});});
    // review/screenshot helpers: #preview=<handle>  #family=<id>
    var hm=location.hash.match(/preview=([\w-]+)/), fm=location.hash.match(/family=([\w-]+)/);
    if(fm) setFam(fm[1]);
    if(hm) colors.forEach(function(c,i){if(c.key===hm[1])activate(i)});
  }
  function boot(){document.querySelectorAll('[data-heart]').forEach(function(r){if(!r.__h){r.__h=1;init(r);}})}
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
})();
